import { useState } from 'react';
import { Banner, BlockStack, Button, Card, InlineStack } from '@shopify/polaris';
import { useTransferRead, type TransferClient } from './useTransferClient';
import type { TransferEvent } from './types';
export function TransferHistory({ client, id, refresh }: { client: TransferClient; id: number; refresh: number }) {
  const [cursor, setCursor] = useState<number | null>(null);
  const { data, error } = useTransferRead<{ events: TransferEvent[]; nextCursor: number | null }>(
    client,
    `/${id}/history${cursor ? '?cursor=' + cursor : ''}`,
    refresh,
  );
  return (
    <Card>
      <BlockStack gap="300">
        <h2>Transfer history</h2>
        {error && <Banner tone="critical">{error}</Banner>}
        {!data && !error && <p>Loading history…</p>}
        {data?.events.map((event) => (
          <div key={event.id}>
            <strong>
              {event.action} · {event.actor_name}
            </strong>
            <p>
              {event.created_at} UTC{event.details.reason ? ' · ' + event.details.reason : ''}
            </p>
            {event.details.reference && <p>Reference: {event.details.reference}</p>}
            {event.details.lines?.map((line) => (
              <p key={line.itemId}>
                Line {line.itemId}: {line.quantity} units{line.damaged ? `; ${line.damaged} damaged` : ''}
                {line.locationId ? `; usable bin ${line.locationId}` : ''}
                {line.holdingId ? `; holding bin ${line.holdingId}` : ''}.
              </p>
            ))}
            {event.details.receiptId && (
              <p>
                Receipt {event.details.receiptId}: {event.details.quantity} units
                {event.details.locationId ? ` to bin ${event.details.locationId}` : ''}.
              </p>
            )}
          </div>
        ))}
        {data && !data.events.length && <p>No recorded actions. Older transfers may have no history.</p>}
        <InlineStack gap="200">
          <Button disabled={!cursor} onClick={() => setCursor(null)}>
            Latest history
          </Button>
          <Button disabled={!data?.nextCursor} onClick={() => setCursor(data?.nextCursor || null)}>
            Older history
          </Button>
        </InlineStack>
      </BlockStack>
    </Card>
  );
}
